import React from "react";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import { getDateString } from "../Utils/GetTimeStamp";

// Define styles for the PDF
const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
  Title: {
    margin: "auto",
    fontSize: 24,
    fontWeight: 600,
    color: "#6366F1",
    marginBottom: 20,
  },
  header: {
    fontSize: 14,
    marginBottom: 5,
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
  },
  tableCell: {
    marginTop: 5,
    fontSize: 12,
    padding: 5,
    borderBottomWidth: 1,
  },
  tableHeader: {
    fontSize: 12,
    backgroundColor: "#71b1fb",
  },
  summary: {
    marginTop: 8,
    width: "50%",
    display: "flex",
    flexDirection: "row",
  },
  summaryCell: {
    width: "50%",
    fontSize: 12,
    fontWeight:"bold"
  },
  sr_no: {
    width: "8%",
  },
  date: {
    width: "15%",
  },
  material: {
    width: "15%",
  },
  quantity: {
    width: "15%",
  },
  trip: {
    width: "10%",
  },
  place: {
    width: "20%",
  },
  amount: {
    width: "15%",
  },
});

const BillPDF = ({ partyDetails, records, summary ,filter}) => (
  <Document title={`${partyDetails[0]?.name||"Unknown"}- Bill ${ getDateString(filter.date_from)} - ${getDateString(filter.date_to)} `}>
    <Page size="A4" style={styles.page}>
      <View>
        <Text style={styles.Title}>Laxmi Traders & Constructions</Text>
      </View>
      <View>
        <Text style={styles.header}>Party Name: {partyDetails[0].name}</Text>
        <Text style={styles.header}>Mobile No: {partyDetails[0].mobile}</Text>
        <Text style={styles.header}>Firm Name: {partyDetails[0].firm}</Text>
        <Text style={styles.header}>Address: {partyDetails[0].address}</Text>
      </View>
      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableRow}>
          <Text style={[styles.tableCell, styles.tableHeader, styles.sr_no]}>
            Sr. No
          </Text>
          <Text style={[styles.tableCell, styles.tableHeader, styles.date]}>
            Date
          </Text>
          <Text style={[styles.tableCell, styles.tableHeader, styles.material]}>
            Material
          </Text>
          <Text style={[styles.tableCell, styles.tableHeader, styles.quantity]}>
            Quantity
          </Text>
          <Text style={[styles.tableCell, styles.tableHeader, styles.trip]}>
            Trip
          </Text>
          <Text style={[styles.tableCell, styles.tableHeader, styles.place]}>
            Place
          </Text>
          <Text style={[styles.tableCell, styles.tableHeader, styles.amount]}>
            Amount
          </Text>
        </View>
        {/* Table Rows */}
        {records?.map((t, i) => (
          <View key={t.docid+i} style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.sr_no]}>{i + 1}</Text>
            <Text style={[styles.tableCell, styles.date]}>
              {getDateString(t.date)}
            </Text>
            <Text style={[styles.tableCell, styles.material]}>
              {t.material}
            </Text>
            <Text style={[styles.tableCell, styles.quantity]}>
              {t.quantity}
            </Text>
            <Text style={[styles.tableCell, styles.trip]}>
              {t.quantity + " " + t.unit}
            </Text>
            <Text style={[styles.tableCell, styles.place]}>{t.to}</Text>
            <Text style={[styles.tableCell, styles.amount]}>{t.bill}</Text>
          </View>
        ))}
        {/* Summary Row */}
        {summary?.quantity?.map(({key,value})=> <View key={key} style={[styles.summary]}>
          <Text style={[styles.summaryCell]}>{key}:</Text>
          <Text style={[styles.summaryCell]}>
            {value + " " + key}
          </Text>
        </View>)}
        <View style={[styles.summary]}>
          <Text style={[styles.summaryCell]}>Bill Amount:</Text>
          <Text style={[styles.summaryCell]}>{summary.totalBill} Rs</Text>
        </View>
      </View>
    </Page>
  </Document>
);

export default BillPDF;
